export default __webpack_public_path__ + "a0a772f1d4f0d4a04f4015cd5f6979d4.jpg";